<template>
  <ProductsViewHeroBase :loading="loading">
    <template #loaded>
      <section class="products-view-hero">
        <HeadingDisplay
          head="Produtos"
          title=""
          :subtitle="hero.totalBalanceUpdatedAt"
        >
          <template #title-component>
            <Money>{{ hero.totalBalance }}</Money>
          </template>
        </HeadingDisplay>

        <div class="products-view-hero__buttons">
          <ButtonBoxDecide
            class="products-view-hero__account-balance"
            icon="BA0130"
            @click="goToTransactions"
          >
            <template #label>
              <ListDisplay
                title="Saldo em conta"
                value=""
                class="products-view-hero__account-balance--display"
              >
                <template #title-slot>
                  <p class="products-view-hero__account-balance--text">
                    Saldo em conta
                  </p>
                </template>
                <template #value-slot>
                  <Money>
                    <p class="products-view-hero__account-balance--text">
                      {{ hero.accountBalance }}
                    </p>
                  </Money>
                </template>
              </ListDisplay>
            </template>
          </ButtonBoxDecide>

          <ButtonBoxLaunch
            v-for="box in hero.buttons"
            :key="box.label"
            :icon="box.icon"
            :label="box.label"
            :disabled="!box.isActive"
            :badge-label="box.chip"
            @click="handleActionClick(box.action)"
          />
        </div>
      </section>
    </template>
  </ProductsViewHeroBase>
</template>

<script lang="ts" setup>
import {
  HeadingDisplay,
  ButtonBoxDecide,
  ListDisplay,
  ButtonBoxLaunch
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { ProductsViewHeroBase } from './components';
import { IHero } from '@/modules/products/services/products';
import { useRouter } from 'vue-router/composables';

interface Props {
  hero: IHero;
  loading: boolean;
}
defineProps<Props>();
const router = useRouter();
function handleActionClick(action: string) {
  if (action === 'CATALOG') {
    router.push({
      name: 'productsCatalog',
      params: {
        type: 'fixed-income'
      }
    });
  }

  if (action === 'ORDERS') {
    window.location.assign(`/products/#/orders`);
  }
}

function goToTransactions() {
  router.push({ name: 'transactions' });
}
</script>

<style scoped lang="less">
.products-view-hero {
  display: flex;
  flex-direction: column;
  gap: @size-spacing-x800;

  &__buttons {
    display: flex;
    align-items: center;
    gap: @size-spacing-x300;

    :deep(.badge-label) {
      background-color: @element-primary;
      color: @base-primary;
      border-radius: @size-radius-max;
    }
  }

  &__account-balance {
    width: 320px;
    height: 132px;
    padding: @size-spacing-x400;

    &--display {
      position: relative;
      top: @size-spacing-x300;
    }

    &--text {
      color: @element-primary;
      .text-p-5();
      font-weight: 600;
    }
  }
}
</style>
